import React from 'react';

function AboutMe() {
    const features = [
        {
            icon: "bi-phone-vibrate-fill",
            title: "Mobile Mastery",
            description: "Building bleeding-edge iOS & Android apps with Flutter that feel native and perform flawlessly."
        },
        {
            icon: "bi-terminal-fill",
            title: "Web Engineering",
            description: "Architecting scalable web ecosystems using React and Node.js with a focus on user experience."
        },
        {
            icon: "bi-shield-lock-fill",
            title: "IT Operations",
            description: "Securing digital assets and managing robust network infrastructures for enterprise stability."
        }
    ];

    return (
        <section id="about" className="py-32 bg-black relative">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-20 items-center">

                    <div className="lg:col-span-5 space-y-8 animate-fade-in-up">
                        <div className="space-y-4">
                            <h2 className="text-green-500 font-black tracking-widest text-sm uppercase">The Narrative</h2>
                            <h3 className="text-5xl md:text-6xl font-black text-white leading-[1.1]">
                                INNOVATION <br />
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-400 to-gray-600">MEETS IMPACT.</span>
                            </h3>
                        </div>

                        <div className="space-y-6">
                            <p className="text-xl text-gray-400 leading-relaxed font-medium border-l-4 border-green-500 pl-8 py-2">
                                Based in the heart of Fort Portal, I am a Computer Science graduate from <span className="text-white">Mountains of the Moon University</span> dedicated to solving real-world challenges through code.
                            </p>
                            <p className="text-lg text-gray-500 leading-relaxed">
                                From agricultural field apps (AMAFA) to complex transport management systems, I craft digital tools that empower users and streamline enterprise operations.
                            </p>
                        </div>

                        <div className="flex items-center gap-8 pt-6">
                            <div>
                                <p className="text-4xl font-black text-white">IT</p>
                                <p className="text-sm font-bold text-gray-600 uppercase">Specialist</p>
                            </div>
                            <div className="w-px h-12 bg-neutral-800"></div>
                            <div>
                                <p className="text-4xl font-black text-white">DEV</p>
                                <p className="text-sm font-bold text-gray-600 uppercase">Engineer</p>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-6">
                        {features.map((feature, index) => (
                            <div
                                key={index}
                                className={`glass-card p-10 rounded-[2.5rem] group hover:border-green-500/30 transition-all duration-500 ${index === 0 ? 'md:col-span-2' : ''}`}
                            >
                                <div className="w-16 h-16 bg-green-500/10 rounded-2xl flex items-center justify-center text-3xl text-green-500 mb-8 border border-green-500/20 group-hover:bg-green-500 group-hover:text-black transition-all duration-500">
                                    <i className={`bi ${feature.icon}`}></i>
                                </div>
                                <h4 className="text-2xl font-black text-white mb-4 uppercase tracking-tighter">{feature.title}</h4>
                                <p className="text-gray-400 text-lg leading-relaxed">{feature.description}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    );
}

export default AboutMe;